import { isPokemon } from './pokemon';

const STORAGE_KEY = 'lastComparison';

export function readStoredMatchup() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed.version !== 2) return null;
    if (!isPokemon(parsed.pokemon1) || !isPokemon(parsed.pokemon2)) return null;
    return { pokemon1: parsed.pokemon1, pokemon2: parsed.pokemon2 };
  } catch {
    return null;
  }
}

export function saveMatchup(pokemon1, pokemon2) {
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ version: 2, pokemon1, pokemon2 })
    );
  } catch {
    // Private mode and full storage should not block the comparison itself.
  }
}
